import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { scrollAppToTop } from "../../utils/scrollToTop";

const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    scrollAppToTop();
  }, [pathname]);

  return null;
};

export default ScrollToTop;
